import { useState } from "react";
import { useOperatorActions } from "../../../../utils/useOperatorActions";
import CyberBoxComponent from "../../../shared/ui/layout/CyberBoxComponent";
import WelcomeComponent from "../day-1/components/welcomeComponent";
import TeamLoaderBoardComponent from "../day-3/components/teamLeaderBoardComponent";

export function Day5() {
  const [currentHtml, setCurrentHtml] = useState(null);
  useOperatorActions("SHOW_TEAMS", () => {
    setCurrentHtml("SHOW_TEAMS");
  });

  const renderHtml = (html) => {
    switch (html) {
      case "SHOW_TEAMS":
        return <TeamLoaderBoardComponent accountTypes="level_5" />;
      default:
        <WelcomeComponent />;
    }
  };
  return (
    <>
      <CyberBoxComponent>{renderHtml(currentHtml)}</CyberBoxComponent>
    </>
  );
}

export default Day5;
